function Footer() {
  return (
    <footer
      className="w-full bg-[#2F3A36] text-white py-10 border-t border-gray-700/30 rounded-t-3xl shadow-2xl"
      style={{ position: 'relative', bottom: 0 }}
    >
      {/* Force padding with higher specificity so it can't be overridden by other styles */}
      <style>{`.footer-inner-force{padding-left:3rem !important;padding-right:1.5rem !important}
        @media (min-width:640px){.footer-inner-force{padding-left:2rem !important;padding-right:2rem !important}}
        @media (min-width:1024px){.footer-inner-force{padding-left:3rem !important;padding-right:3rem !important}}`}</style>
      <div className="max-w-6xl mx-auto footer-inner-force">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 pb-6 border-b border-gray-700/20">
          <div>
            <h3 className="text-[#3a8b9e] font-bold text-base mb-2 tracking-wide">Contact</h3>
            <ul className="space-y-1 text-base">
              <li>
                <span className="font-semibold">Email:</span> <a href="mailto:info@VenturePoint-Egypt.com" className="underline hover:text-[#3a8b9e] transition">info@VenturePoint-Egypt.com</a>
              </li>
              <li>
                <span className="font-semibold">Phone:</span> <span>+201003400202</span>
              </li>
              <li>
                <span className="font-semibold">Phone:</span> <span>+1202-390-4405</span>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-[#3a8b9e] font-bold text-base mb-2 tracking-wide">Address</h3>
            <a
              href="https://www.google.com/maps/dir//Mindhaus+-+District+5+Ain+El+Sokhna+Rd+New+Cairo+3+Cairo+Governorate+4064070/@29.9526493,31.4488469,19z/data=!4m5!4m4!1m0!1m2!1m1!1s0x145825a012334e89:0xe3fa4501ecc08437"
              target="_blank"
              rel="noopener noreferrer"
              className="text-base leading-relaxed underline hover:text-[#3a8b9e] transition"
            >
              District 5 Mindhaus Campus,<br />Building B01-M05, B01-G05, New Cairo, Egypt
            </a>
          </div>
          <div>
            <h3 className="text-[#3a8b9e] font-bold text-base mb-2 tracking-wide">Quick Links</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-1 text-base">
              <li><a href="/" className="hover:text-[#3a8b9e] transition">Home</a></li>
              <li><a href="/team" className="hover:text-[#3a8b9e] transition">Founders</a></li> 
              <li><a href="/about" className="hover:text-[#3a8b9e] transition">Our Story</a></li>
              <li><a href="/services" className="hover:text-[#3a8b9e] transition">Services</a></li>
                <li><a href="/advisors" className="hover:text-[#3a8b9e] transition">Advisors</a></li>
              <li><a href="/projects" className="hover:text-[#3a8b9e] transition">Projects</a></li>
              <li><a href="/partners-list" className="hover:text-[#3a8b9e] transition">Partners</a></li>
              <li><a href="/events" className="hover:text-[#3a8b9e] transition">Events</a></li>
              <li><a href="/articles" className="hover:text-[#3a8b9e] transition">Publications</a></li>
              <li><a href="/contact" className="hover:text-[#3a8b9e] transition">Contact</a></li>   
            </ul>
          </div>
          <div>
            <h3 className="text-[#3a8b9e] font-bold text-base mb-2 tracking-wide">Follow Us</h3>
            <div className="flex gap-4 mt-2">
              <a href="https://www.linkedin.com/company/venturepoint-for-economic-development/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-base hover:text-[#3a8b9e] transition"> LinkedIn</a>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center pt-6 text-base text-gray-50/80">
          <span className="text-[#3a8b9e]">&copy; {new Date().getFullYear()} VenturePoint for Economic Development, LLC (VPED).</span>
          <span className="mt-2 sm:mt-0 text-white">All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;